export const SUCCESS_GET_PROGRESS = 'SUCCESS_GET_PROGRESS';
export const FAILED_GET_PROGRESS = 'FAILED_GET_PROGRESS';



// WEBPACK FOOTER //
// ./src/state/constants/pollConstants.js